import {
  BusinessColId,
  LivestockSaleColumnDefinitions,
} from "constants/columnDefinitions";
import { ColumnType } from "components/AgGrid/constants";
import { LivestockSaleColId } from "constants/columns";
import { ACTION_COLUMN_NAME } from "constants/aggrid";
import { LivestockSaleActionsColumnRenderer } from "lib/agGrid/renderers/livestockSale";
import {
  SaleRolesEditor,
  SaleRolesRenderer,
} from "lib/agGrid/renderers/SaleRolesRenderer";
import { SaleRoleKind } from "components/SaleRolesSelect";
import { ColDef } from "ag-grid-community";
import { LivestockSaleAgGridRowType } from "selectors/aggrid/sales";

export const columnDefs: ColDef<LivestockSaleAgGridRowType>[] = [
  LivestockSaleColumnDefinitions[LivestockSaleColId.DATE],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SALE_CODE],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SALE_SUB_TYPE],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SALE_TYPE],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SALEYARD],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SPECIES_NAME],
  LivestockSaleColumnDefinitions[LivestockSaleColId.TITLE],

  {
    headerName: ACTION_COLUMN_NAME,
    colId: BusinessColId.ACTIONS,
    field: "livestockSale.id",
    pinned: "right",
    cellRenderer: LivestockSaleActionsColumnRenderer,
    width: 140,
  },
];

export const agentColumnDefs = [
  ...columnDefs,
  LivestockSaleColumnDefinitions[LivestockSaleColId.STATUS],
  LivestockSaleColumnDefinitions[LivestockSaleColId.COMMENTS],
];

const saleRoleColumn = (
  colId: string,
  headerName: string,
  field: ColDef<LivestockSaleAgGridRowType>["field"],
  roleKind: SaleRoleKind,
  canEdit: boolean,
): ColDef<LivestockSaleAgGridRowType> => ({
  colId,
  headerName,
  type: ColumnType.STRING,
  field,
  enableRowGroup: true,
  // Filter on individual names (an array) rather than the joined label, so the
  // set filter lists each person instead of every comma-separated combination.
  filterValueGetter: params =>
    params.data?.livestockSale?.[
      roleKind === SaleRoleKind.Managers ? "managerNames" : "assigneeNames"
    ] ?? [],
  cellRenderer: SaleRolesRenderer,
  cellRendererParams: { roleKind, canEdit },
  editable: canEdit,
  ...(canEdit
    ? {
        cellEditor: SaleRolesEditor,
        cellEditorParams: { roleKind, canEdit },
        cellEditorPopup: true,
        cellEditorPopupPosition: "over" as const,
        singleClickEdit: true,
      }
    : {}),
});

/**
 * Manager / Assignee columns, shown only when the sale-roles feature is on.
 * `canEdit` toggles inline editing (gated by the dedicated permission).
 */
export const saleRoleColumnDefs = (
  canEdit: boolean,
): ColDef<LivestockSaleAgGridRowType>[] => [
  saleRoleColumn(
    LivestockSaleColId.MANAGERS,
    "Managers",
    "livestockSale.managersLabel",
    SaleRoleKind.Managers,
    canEdit,
  ),
  saleRoleColumn(
    LivestockSaleColId.ASSIGNEES,
    "Assignees",
    "livestockSale.assigneesLabel",
    SaleRoleKind.Assignees,
    canEdit,
  ),
];
